module.exports = __webpack_public_path__ + "static/img/statistics_icon_gray.5300ddd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/statistics_icon_gray.png
// module id = iGqH
// module chunks = 1